/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import {
	CosmosRichTextFragment,
	ComplexCtaCardFragment,
	CosmosEnumComplexCtaVariant,
	ComplexCtaCardsSectionFragment,
} from "@cosmos/hygraph-schema";

import { CosmosRichText } from "@components/elements";
import { css, cx } from "@panda/css";
import { Flex } from "@panda/jsx";
import { grid, gridItem, stack } from "@panda/patterns";

import { ComplexCtaCard } from "./ComplexCtaCard.molecule";

export type ComplexCtaCardsProps = {
	cards?: ComplexCtaCardFragment[] | null;
	bottomDescription?: CosmosRichTextFragment | null;
	complexCtaVariant?: ComplexCtaCardsSectionFragment["complexCtaVariant"];
};

const styled = css({
	mdDown: {
		gap: "eds.dimension.48",
	},
});

export function ComplexCtaCards({
	cards = [],
	bottomDescription,
	complexCtaVariant,
}: ComplexCtaCardsProps): React.JSX.Element {
	const columnBase = complexCtaVariant === CosmosEnumComplexCtaVariant.FourColumns ? 4 : 3;
	return (
		<Flex direction="column" className={`${styled}`} gap="eds.dimension.16">
			<div
				className={cx(
					"complex-cta-cards",
					css({ w: "full", h: "full" }),
					stack({ direction: "column", gap: "eds.dimension.16" }),
				)}
			>
				<div
					className={cx(
						grid({
							columnGap: "eds.dimension.16",
							rowGap: "eds.dimension.16",
							columns: { base: columnBase, mdDown: 2, smDown: 1 },
						}),
					)}
				>
					{(cards || []).map((card, i) => (
						<div className={gridItem({ colSpan: 1 })} key={`complex-cta-card-grid-item-${i}`}>
							<ComplexCtaCard {...card}></ComplexCtaCard>
						</div>
					))}
				</div>
			</div>
			<CosmosRichText {...bottomDescription} color="eds.text.secondary" variant="paragraphSM" />
		</Flex>
	);
}
